import { Component, OnInit } from '@angular/core';

import { MenuBlock, MenuTab, MenuItem } from './menu-service-block.model';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { UserService } from './services/user.service';


@Component({
  selector: 'wm-menu-service-block',
  template: require('./menu-service-block.component.html'),
})

export class MenuServiceBlockComponent implements OnInit {
  tabsMenu:     MenuTab[];
  tabsItems:    MenuItem[];
  userRole:     string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private user: UserService,
    private menu: MenuBlock
  ) {
    this.userRole = this.user.currentUser['role'];
    this.initMenuRole(this.userRole);
  }

  ngOnInit() {
    this.router.events
      .filter(event => event instanceof NavigationEnd)
      .subscribe(event => {
        let currentRoute = this.route.root;
        while (currentRoute.children[0] !== undefined) {
          currentRoute = currentRoute.children[0];
        }

        if (this.user.currentUser['role'] !== this.userRole) {
          this.userRole = this.user.currentUser['role'];
          this.initMenuRole(this.userRole);
        }

        this.activateTab(currentRoute.snapshot.data['tab_name']);
      });
  }

  initMenuRole(role = '') {
    this.tabsMenu = this.menu.tabs.filter((tab) => {
      if (!!tab['roles'] && !tab['roles'].includes(role)) {
        return false;
      } else {
        return true;
      }
    });
  }

  checkActive(tab_route) {
    if (!!this.menu.tabSelected && this.menu.tabSelected.route === tab_route) {
      return true;
    } else {
      return false;
    }
  }

  activateTab(name) {
    this.menu.tabs.forEach((tab) => {
      if (tab['name'] === name) {
        this.menu.tabSelected = tab;
        this.tabsItems = tab['subtabs'];
      }
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/menu-service-block.component.ts